/**
 * Regional Translations Module (Spanish)
 * Matches English structure exactly
 * @module regional
 * @language es
 */

export const regional = {
  regional: {
    title: "Análisis Regional",
    subtitle: "Miembros activos por región geográfica",
    asiaPacific: "Asia y el Pacífico",
    europe: "Europa",
    americas: "América",
    africaMiddleEast: "África y Oriente Medio"
  },
  regionalAnalysisPage: {
    pageSubtitle: "1.000+ proyectos • 148.122 miembros • 4.641 Organizaciones Locales en 4 regiones JCI"
  },
  regionalDistribution: {
    title: "Distribución Regional",
    subtitle: "1.000+ proyectos en 4 regiones JCI en 2024-2025",
    totalMembers: "Total de Miembros",
    localOrganizations: "Organizaciones Locales",
    countries: "Países",
    annualProjects: "Proyectos Anuales",
    projectDistributionTitle: "Distribución de Proyectos por Región (2024-2025)",
    projects: "proyectos",
    risePillarTitle: "Distribución de Pilares JCI RISE",
    total: "Total",
    mentalHealth: "Salud Mental",
    mentalHealthBeneficiaries: "5,9M+ beneficiarios alcanzados",
    workforceResilience: "Resiliencia Laboral",
    workforceDesc: "Habilidades y apoyo al empleo",
    economicRecovery: "Recuperación Económica",
    economicDesc: "Emprendimiento y crecimiento económico",
    totalBeneficiaries: "Total de beneficiarios alcanzados a través de 1000+ proyectos JCI",
    membershipDistributionTitle: "Distribución de Miembros por Región",
    fiiScore: "Puntuación FII",
    members: "Miembros",
    localOrgs: "Orgs Locales",
    projectShare: "Participación en Proyectos",
    fastest: "Más Rápido",
    emerging: "Emergente",
    stable: "Estable",
    consolidating: "Consolidando",
    fastestGrowing: "Crecimiento Más Rápido",
    emergingPotential: "Potencial Emergente",
    sourceNote: "Fuente: Informe de Impacto JCI 2025 - Datos regionales oficiales"
  },
  regionalAnalysis: {
    title: "Análisis Regional del FII",
    subtitle: "Rendimiento regional del Índice de Inversión Futura a través de 114 países",
    overview: "Visión General",
    regionalPerformance: "Rendimiento Regional",
    top5ByRegion: "Top 5 por Región",
    regionalComparison: "Comparación Regional",
    fiiScore: "Puntuación FII",
    mentalHealth: "Salud Mental",
    workforce: "Fuerza Laboral",
    entrepreneurship: "Emprendimiento",
    region: "Región",
    avgScore: "Punt. Promedio",
    topCountry: "País Top",
    gap: "Brecha con Top",
    regionalInsights: "Perspectivas Regionales",
    keyStrengths: "Fortalezas Clave",
    challenges: "Desafíos",
    jciOpportunity: "Oportunidad JCI",
    europe: {
      name: "Europa",
      strength1: "Sistemas de salud mental más fuertes globalmente",
      strength2: "Alta inversión en educación",
      strength3: "Ambiente empresarial estable",
      challenge1: "Sur/Este se quedan atrás de Nórdicos",
      challenge2: "Desempleo juvenil en Europa del Sur",
      opportunity: "Escalar organizaciones locales de alto rendimiento como modelos; mentoría empresarial"
    },
    asiaPacific: {
      name: "Asia y el Pacífico",
      strength1: "Economías en rápido crecimiento",
      strength2: "Sólidos sistemas educativos (Este de Asia)",
      strength3: "Soluciones digitales escalables",
      challenge1: "Alto estigma cultural de salud mental",
      challenge2: "Amplia variación dentro de la región",
      opportunity: "Enfoque digital-first; campañas anti-estigma centradas en jóvenes"
    },
    americas: {
      name: "América",
      strength1: "Economía fuerte de América del Norte",
      strength2: "Ecosistema emprendedor en crecimiento",
      strength3: "Adopción de telesalud",
      challenge1: "Grandes brechas en América Latina",
      challenge2: "Desigualdad de acceso",
      opportunity: "Proyectos RISE en América Latina; asociaciones corporativas"
    },
    africaMe: {
      name: "África y Oriente Medio",
      strength1: "Población más joven",
      strength2: "Alta aspiración emprendedora",
      strength3: "Adopción mobile-first",
      challenge1: "Acceso limitado a salud mental",
      challenge2: "Desempleo juvenil persistente",
      challenge3: "Brecha de financiamiento",
      challenge4: "Infraestructura limitada",
      challenge5: "Acceso a servicios de salud mental, brechas de tratamiento, cobertura de políticas",
      challenge6: "Brecha crítica: solo 10-30% de cobertura de servicios vs 70%+ en Europa",
      opportunity: "Apoyo entre pares no clínico; microfinanzas + mentoría"
    },
    limitedData: "Datos Limitados",
    dimensionLeaders: "Líderes por Dimensión",
    regionalTrends: "Tendencias Regionales",
    expandRegion: "Expandir región",
    gapBetweenBestWorst: "Brecha entre mejor y peor:",
    gapIndicatesInequality: "Esta brecha indica desigualdad global significativa en oportunidades de la juventud",
    bestPerforming: "Mejor Rendimiento",
    countriesWithData: "Países con Datos:",
    strengths: "Fortalezas",
    recommendations: "Recomendaciones"
  },
  mapExplorer: {
    title: "Explorador de Mapas Interactivo",
    subtitle: "Explorar puntuaciones FII, membresía JCI y proyectos RISE por país",
    searchCountry: "Buscar país...",
    mapView: "Vista de Mapa",
    filters: "Filtros",
    colorBy: "Colorear por",
    fiiScore: "Puntuación FII",
    mentalHealth: "Salud Mental",
    workforce: "Fuerza Laboral",
    entrepreneurship: "Emprendimiento",
    jciMembers: "Miembros JCI",
    riseProjects: "Proyectos RISE",
    showOnlyJciCountries: "Mostrar solo países JCI",
    membershipThreshold: "Umbral de Membresía",
    members: "Miembros",
    projects: "Proyectos",
    selectedCountry: "País Seleccionado",
    noCountrySelected: "Ningún país seleccionado",
    selectCountryFromMap: "Seleccione un país del mapa para ver detalles",
    fiiRank: "Rango FII",
    of114: "de 114",
    regionalRank: "Rango Regional",
    memberCount: "Miembros JCI",
    noMembership: "Sin membresía JCI",
    projectCount: "Proyectos RISE",
    active: "Activos",
    noProjects: "Sin proyectos activos",
    dimensionBreakdown: "Desglose de Dimensiones",
    score: "Puntuación",
    recentProjects: "Proyectos Recientes",
    viewDetails: "Ver Detalles",
    noProjectsForCountry: "Sin proyectos activos para este país",
    topPerformers: "Mejores Rendimientos",
    globalTop10: "Top 10 Global",
    regionalTop5: "Top 5 Regional",
    countryDetails: "Detalles del País",
    jciPresence: "Presencia JCI",
    regionalContext: "Contexto Regional",
    compareWith: "Comparar con",
    global: "Global",
    regionalAverage: "Promedio Regional",
    insights: "Perspectivas",
    downloadData: "Descargar Datos",
    shareMap: "Compartir Mapa",
    exportImage: "Exportar Imagen"
  },
  clusterAnalysis: {
    title: "Grupos de Países del FII",
    subtitle: "114 países agrupados por características de oportunidad similares",
    cluster: "Grupo",
    clusterName: "Nombre del Grupo",
    countries: "Países",
    avgFiiScore: "Punt. FII Prom.",
    characteristics: "Características",
    cluster1: {
      name: "Líderes Globales",
      desc: "Condiciones óptimas a través de las 3 dimensiones",
      countries: "13 países",
      avgScore: "85+",
      examples: "Noruega, Dinamarca, Suiza"
    },
    cluster2: {
      name: "Economías de Alto Rendimiento",
      desc: "Fuertes en 2/3 dimensiones",
      countries: "22 países",
      avgScore: "75-85",
      examples: "Alemania, Australia, Canadá"
    },
    cluster3: {
      name: "Mercados Emergentes Fuertes",
      desc: "Crecimiento rápido pero brechas de infraestructura",
      countries: "28 países",
      avgScore: "60-75",
      examples: "Chile, Malasia, Polonia"
    },
    cluster4: {
      name: "Regiones en Desarrollo",
      desc: "Crecimiento de la juventud pero desafíos de sistemas",
      countries: "31 países",
      avgScore: "45-60",
      examples: "India, Perú, Filipinas"
    },
    cluster5: {
      name: "Alerta de Crisis",
      desc: "Intervenciones urgentes necesarias",
      countries: "20 países",
      avgScore: "<45",
      examples: "Yemen, Chad, Afganistán"
    },
    clusterFeatures: "Características del Grupo",
    mentalHealthAccess: "Acceso MH",
    youthUnemployment: "Desempleo Juvenil",
    entrepreneurshipIndex: "Índice Emprendedor",
    educationIndex: "Índice Educativo",
    digitalInfrastructure: "Infraestructura Digital",
    politicalStability: "Estabilidad Política",
    jciRecommendations: "Recomendaciones JCI",
    recommendation1: "Escalar programas RISE en Grupos 4-5",
    recommendation2: "Replicar modelos de Grupo 1-2 en regiones similares",
    recommendation3: "Enfoque en salud mental para Grupo 3",
    recommendation4: "Asociaciones de fuerza laboral en todas partes",
    viewFullClusters: "Ver Análisis Completo de Grupos"
  }
} as const;
